import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setLoader } from "./MasterSlice";
import * as API from "../../utils/api.service";
import { TOAST_SUCCESS } from "../../utils/common.service";
import { data } from "jquery";

export const getChallengeApiCall = createAsyncThunk("challengeList", async (submitData, { dispatch }) => {
    try {
        dispatch(setLoader(true))
        const { data: challengeList } = await API.getChallengeApi(submitData);
        //  console.log("*********************************************",letterList);
        dispatch(setLoader(false))
        return challengeList;
    } catch (error) {
        throw error;
    }
});

export const editChallengeApiCall = createAsyncThunk("editChallengeListData", async (submitData, { dispatch }) => {
    try {
        dispatch(setLoader(true))
        //console.log("000000000000000000000000000000000000",submitData);
        
        const { data: editChallengeData, code, message } = await API.updateChallengeApi(submitData);
        if (code === '1') {
            //TOAST_SUCCESS(message);
        }
        dispatch(setLoader(false))
        return { data: editChallengeData, code, message };
    } catch (error) {
        throw error;
    }
});

const initialState = {
    challengeList: {
        data: [],
        error: null,
    },
    editChallengeData: {
        data: null,
        code: '',
        message: '',
        error: null,
    },
};

const ChallengeSlice = createSlice({
    name: "CLIENT",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getChallengeApiCall.fulfilled, (state, action) => {
                state.challengeList.data = action.payload;
            })
            .addCase(getChallengeApiCall.rejected, (state, action) => {
                state.challengeList.error = action.error.message;
            })
            .addCase(editChallengeApiCall.fulfilled, (state, action) => {
                const { message, code, data } = action.payload;
                state.editChallengeData.data = data;
                state.editChallengeData.message = message;
                state.editChallengeData.code = code;
            })
            .addCase(editChallengeApiCall.rejected, (state, action) => {
                state.editChallengeData.error = action.error.message;
            });
    },
});

export default ChallengeSlice.reducer;